itsoftApp.createModule("disclaimer", ["windowResize"], function () {
    var pageFooter = document.querySelector(".page-footer");
    var disclaimer = document.querySelector(".disclaimer");
    var disclaimerButton = document.querySelector(".disclaimer__close-button");
    var disclaimerConfirm = document.querySelector(".disclaimer__confirm");
    var lwrapper = document.querySelector(".l-wrapper");

    var buttonMouseOver = function (evt) {
        if (!disclaimer.classList.contains("js-hover")) {
            disclaimer.classList.add("js-hover");
            if (disclaimerConfirm) {
                disclaimerConfirm.addEventListener("mouseout", buttonMouseOut);
            }
        }
    }

    var buttonMouseOut = function (evt) {
        setTimeout(function () {
            disclaimer.classList.remove("js-hover");
            if (disclaimerConfirm) {
                disclaimerConfirm.removeEventListener("mouseout", buttonMouseOut);
            }
        }, 2000)
    }

    var disclaimerClose = function () {
        disclaimer.classList.add("js-static");
        disclaimer.classList.add("js-inactive");
        if (disclaimer.classList.contains("js-hover")) {
            disclaimer.classList.remove("js-hover");
        }
        if (disclaimerConfirm) {
            disclaimerConfirm.style.display = "none";
        }
        pageFooter.classList.add("js-update");
    }

    disclaimerButton.addEventListener("mouseover", buttonMouseOver);

    if (disclaimerConfirm) {
        disclaimerConfirm.addEventListener("click", function (evt) {
            evt.preventDefault();
            disclaimerClose();
        });
    }

    disclaimerButton.addEventListener("click", function (evt) {
        evt.preventDefault();
        disclaimerClose();
    });

    var footerCoordY;

    var defineCoordY = function () {
        footerCoordY = pageFooter.getBoundingClientRect().top + pageYOffset;
    }

    var checkElementCoords = function () {
        var s_top = pageYOffset;

        if (s_top + document.documentElement.clientHeight > footerCoordY) {
            disclaimerButton.classList.add("js-close-hide");
            disclaimer.classList.add("js-inactive");
        } else if (!disclaimer.classList.contains("js-static")) {
            disclaimerButton.classList.remove("js-close-hide");
            disclaimer.classList.remove("js-inactive");
        } else {
            document.removeEventListener("scroll", onDocumentScroll);
            window.removeEventListener("resize", onDocumentResize);
        }
    }

    var onDocumentScroll = function () {
        checkElementCoords();
    }

    var onDocumentResize = function () {
        defineCoordY();
        checkElementCoords();
    }

    defineCoordY();
    checkElementCoords();

    document.addEventListener("scroll", onDocumentScroll);
    window.addEventListener("resize", onDocumentResize);
});